<h2 *ngIf="mode === 'add'; else editDialoge" mat-dialog-title>
  {{ "Masters.Coupon.Add" | translate }}
</h2>
<ng-template #editDialoge>
  <h2 mat-dialog-title>{{ "Masters.Coupon.Edit" | translate }}</h2>
</ng-template>
<mat-divider></mat-divider>
<div class="state-dialog" [formGroup]="formGroup">
  <mat-form-field class="testName">
    <input matInput placeholder="Coupon Name" formControlName="name" />
  </mat-form-field>
  <mat-form-field class="testName">
    <mat-select placeholder="Coupon Type" formControlName="couponType">
      <mat-option [value]="1"> Percentage </mat-option>
      <mat-option [value]="2"> Fixed </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="testName">
    <mat-select placeholder="Applicable In" formControlName="usage" multiple>
      <mat-option [value]="2"> Pharmacy </mat-option>
      <mat-option [value]="1"> Appointment </mat-option>
      <mat-option [value]="3"> Service </mat-option>
      <mat-option [value]="4"> Packages </mat-option>
      <mat-option [value]="5"> Store Bill </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field class="testName">
    <input
      placeholder="Expiry Date"
      matInput
      readonly
      required
      [matDatepicker]="picker"
      formControlName="expiredAt"
      [min]="today"
    />
    <mat-datepicker-toggle matSuffix [for]="picker"> </mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
  <mat-form-field class="testName">
    <input matInput placeholder="Coupon Value" formControlName="value" />
  </mat-form-field>
  <mat-form-field class="testName">
    <input matInput placeholder="Max Discount" formControlName="maxDiscount" />
  </mat-form-field>
  <mat-form-field class="testName">
    <input matInput placeholder="Description" formControlName="description" />
  </mat-form-field>
  <mat-form-field class="testName">
    <input matInput placeholder="maximum User" formControlName="maxUser" />
  </mat-form-field>
  <mat-dialog-actions align="end" fxLayoutGap="20px">
    <button class="mat-raised-button mat-secondary" (click)="close()">
      {{ "Close" | translate }}
    </button>
    <button
      *ngIf="mode === 'add'; else updateButton"
      class="mat-raised-button mat-primary"
      (click)="add()"
    >
      {{ "Add" | translate }}
    </button>
    <ng-template #updateButton>
      <button class="mat-raised-button mat-primary" (click)="add()">
        {{ "Update" | translate }}
      </button>
    </ng-template>
  </mat-dialog-actions>
</div>
